import ReactGA, { EventArgs, TrackerNames } from "react-ga";

export const eventAnalytic = (args: EventArgs, trackerName?: TrackerNames) => {
  ReactGA.event(args, trackerName);
};
